export default __webpack_public_path__ + "static/media/land-1.e9b9ec6c.webp";